<template>
  <MglGeojsonLayer
    :source-id="source.id"
    :source="source.json"
    :layer-id="layer.id"
    :layer="layer.json"
  />
</template>

<script>
import axios from 'axios'
import Mapbox from 'mapbox-gl'
import { MglGeojsonLayer } from 'vue-mapbox'

export default {
  name: 'RhumbLayer',
  inject: ['mapbox', 'map', 'actions'],
  components: {
    MglGeojsonLayer
  },
  props: {
    raceId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: 'true',
      rhumbData: [],
      layer: {
        id: 'rhumbline',
        json: {
          'type': 'line',
          'source': 'rhumbline-source',
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': '#0000FF',
            'line-width': 1
          }
        }
      }
    }
  },
  computed: {
    source () {
      var coords = []

      for (var i = 0; i < this.rhumbData.length; i++) {
        coords.push([this.rhumbData[i].Longitude, this.rhumbData[i].Latitude])
      }

      return {
        id: 'rhumbline-source',
        json: {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'LineString',
              'coordinates': coords
            }
          },
          'cluster': false
        }
      }
    }
  },
  async created () {
    this.fetchRhumbLine()
    this.loading = false
  },
  methods: {
    fetchRhumbLine () {
      axios
      .get(`${window.BASE_FEEDS_URL}Course/Rhumbline/${this.raceId}`)
      .then(response => {
        this.rhumbData = response.data
      })
      .catch(error => {
        this.errored = true
        // eslint-disable-next-line
          console.log(error)
      })
      .then(() => this.loading = false)
    },
  }
}
</script>